import { CreateConfig } from '@carvana/analytics';
import GoogleTagManagerClient from './analytics-scripts/google-tag-manager';
import FullStoryClient from './analytics-scripts/fullstory';

export default new CreateConfig({
  gtm: new GoogleTagManagerClient({
    id: process.env.ANALYTICS_GOOGLE_TAG_MANAGER_ID
  }),
  fullstory: new FullStoryClient({}),
  debug: process.env.NODE_ENV !== 'production',
  noPublish: false
});
